import type { ReactElement } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export default function StripeConnectEmbeddedSurfaceSkeleton({
  className,
  rows = 4,
  showSummary = false,
}: {
  className?: string
  rows?: number
  showSummary?: boolean
}): ReactElement {
  return (
    <div
      role="status"
      aria-label="Loading Stripe tools"
      className={cn('flex min-h-[inherit] w-full flex-col gap-5 rounded-md p-4', className)}
    >
      {showSummary ? (
        <div className="grid gap-3 sm:grid-cols-3">
          {[0, 1, 2].map((item) => (
            <div className="space-y-3 rounded-md bg-muted/35 p-3" key={item}>
              <Skeleton tone="neutral" className="h-3 w-16" />
              <Skeleton tone="neutral" className="h-6 w-24" />
              <Skeleton tone="neutral" className="h-3 w-20" />
            </div>
          ))}
        </div>
      ) : null}

      <div className="space-y-4">
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton tone="neutral" className="h-4 w-40 max-w-full" />
            <Skeleton tone="neutral" className="h-3 w-64 max-w-full" />
          </div>
          <Skeleton tone="neutral" className="h-8 w-24 shrink-0 rounded-full" />
        </div>

        <div className="space-y-3">
          {Array.from({ length: rows }).map((_, index) => (
            <div
              className="grid grid-cols-[minmax(0,1fr)_6rem] items-center gap-4 rounded-md bg-muted/25 p-3"
              key={index}
            >
              <div className="min-w-0 space-y-2">
                <Skeleton tone="neutral" className="h-3 w-36 max-w-full" />
                <Skeleton tone="neutral" className="h-3 w-3/4 max-w-full" />
              </div>
              <Skeleton tone="neutral" className="h-7 w-20 justify-self-end rounded-full" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
